<script setup>
import { computed, defineEmits, defineProps } from 'vue';

const emit = defineEmits(['click']);
const props = defineProps({
  currentIndex: {
    required: true,
    type: Number,
  },
  index: {
    required: true,
    type: Number,
  },
  setSize: {
    required: true,
    type: Number,
  },
  startingIndex: {
    default: 0,
    required: false,
    type: Number,
  },
});

const selected = computed(() => props.currentIndex === props.startingIndex + props.index);
const posInSet = computed(() => props.startingIndex + props.index + 1);
const id = computed(() => `option__${props.index}`);

function clickHandler() {
  emit('click');
}
</script>

<template>
  <li
    @click="clickHandler"
    :aria-posinset="posInSet"
    :aria-selected="selected"
    :aria-setsize="props.setSize"
    :id="id"
    class="c-listbox__option"
    role="option"
  >
    <slot />
  </li>
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/mixins/focus';
@import '@/ui/styles/mixins/transitions';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/fonts';
@import '@/ui/styles/settings/units';

.c-listbox__option {
  @include defaultTransition;
  display: block;
  padding: $spacing-small rem(20px);
  color: $color-neutral-dark;
  font-size: rem(16px);
  font-weight: $font-weight-semi-bold;
  line-height: $line-height-regular;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;

  &[aria-selected='true'] {
    @include focus-outline;
    outline-offset: -#{$outline-width-medium};
  }

  &:hover {
    color: $color-brand-one;
  }
}
</style>
